import * as THREE from "three";
import {gsap} from "gsap";
import services from "./services";
import {checkDeviceMobile} from "./helper";
import EmitEvent, {HT_RESIZE, PAGE_ENTER, PAGE_LEAVE, PAGE_LOADED} from "./emit-event";

//import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";

class ThreeSketch {
    constructor() {
        this.perspective = 500;
        this.looper = [];
        this.textures = [];
        if (!checkDeviceMobile()) {
            this.init();
            this.bindEvent();
        }
    }

    init() {
        this.renderer = new THREE.WebGLRenderer({alpha: true, antialias: true});
        this.renderer.setSize(services.winSize.width, services.winSize.height, false);
        this.renderer.setPixelRatio(window.devicePixelRatio);
        document.body.appendChild(this.renderer.domElement);

        const fov = (180 * (2 * Math.atan(services.winSize.height / 2 / this.perspective))) / Math.PI;
        this.camera = new THREE.PerspectiveCamera(fov, services.winSize.aspectRatio, 1, 1000);
        this.camera.position.set(0, 0, this.perspective);

        this.scene = new THREE.Scene();
        this.loader = new THREE.TextureLoader();
        //   this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.render = this.render.bind(this);
        this.pageEnter = this.pageEnter.bind(this);
        this.pageLeave = this.pageLeave.bind(this);

    }

    loadTexture({src}) {
        return new Promise((resolve, reject) => {
            this.loader.load(src, resolve, undefined, reject)
        });
    }

    loadTextures(urls, addTextures) {
        return new Promise((resolve, reject) => {
            const texture = {
                placeholder: this.loader.load(urls.placeholder, resolve, undefined, reject),
                origin: this.loader.load(urls.origin),
            }
            addTextures(texture);
        });
    }

    initLoadTextures(urls, addTextures, loaded) {
        Promise.all([...urls].map((url) => {
            this.loadTextures(url, addTextures);
        })).then(loaded);
    }

    addGroup(gr) {
        this.scene.add(gr);
    }

    removeGroup(gr) {
        this.scene.remove(gr);
    }

    addLoop(looper) {
        this.looper.push(looper);
    }

    removeLoop(looper) {
      // dang lam
    }

    render() {
        for (let i = 0; i < this.looper.length; i++) {
            this.looper[i]();
        }
        this.renderer.render(this.scene, this.camera);
    }

    pageEnter() {
        gsap.ticker.add(this.render);
    }

    pageLeave() {
        this.looper = [];
        gsap.ticker.remove(this.render);
    }

    winResize() {
        this.renderer.setSize(services.winSize.width, services.winSize.height);
        const fov = (180 * (2 * Math.atan(services.winSize.height / 2 / this.perspective))) / Math.PI;
        this.camera.aspect = services.winSize.aspectRatio;
        this.camera.fov = fov;
        this.camera.updateProjectionMatrix();
    }

    bindEvent() {
        EmitEvent.on(HT_RESIZE, this.winResize.bind(this));
        EmitEvent.on(PAGE_LOADED, this.pageEnter);
        EmitEvent.on(PAGE_LEAVE, this.pageLeave);
    }
}

export default new ThreeSketch();